// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2W3PE","content":"styles-module--content--36UEJ","img":"styles-module--img--1bcN8"};